import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ILoginRequest } from './auth.interface';
import { MatidorAdminService } from '../matidor-admin/matidor-admin.service';
import { IUser } from '../matidor-admin/users/user.interface';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly _router = inject(Router);
  private readonly _httpClient = inject(HttpClient);
  private readonly _matidorAdminService = inject(MatidorAdminService);

  async login(payload: ILoginRequest) {
    try {
      const response = await firstValueFrom(this._httpClient.post<IUser>(`${environment.apiUrl}/api/private/v1/authentication/signin`, payload));

      await this._matidorAdminService.setCurrentUser(response);
    } catch (error) {
      throw error;
    }
  }

  async logout(): Promise<void> {
    await firstValueFrom(this._httpClient.post<void>(`${environment.apiUrl}/api/private/v1/authentication/signout`, null));

    this._router.navigate(['/login']);
  }
}
